import Spline from '@splinetool/react-spline';

export default function GengarPlay(props) {
  return (
    <Spline scene="https://prod.spline.design/pXtJloPMJe1LhUnK/scene.splinecode" onClick={props.onGame}/>
  );
}
